import * as betprofessor from './TabBar.styles.betprofessor';
import * as betroyale from './TabBar.styles.betroyale';
import * as fiestabet from './TabBar.styles.fiestabet';
import * as puntcity from './TabBar.styles.puntcity';
import * as puntgenie from './TabBar.styles.puntgenie';
import * as questbet from './TabBar.styles.questbet';
import * as sterlingparker from './TabBar.styles.sterlingparker';
import * as vikingbet from './TabBar.styles.vikingbet';
import * as volcanobet from './TabBar.styles.volcanobet';
import * as wellbet from './TabBar.styles.wellbet';
import * as goldenrush from './TabBar.styles.goldenrush';
import * as juicybet from './TabBar.styles.juicybet';
import * as forsport from './TabBar.styles.forsport';
import * as junglebet from './TabBar.styles.junglebet';
import * as betgalaxy from './TabBar.styles.betgalaxy';
import * as sugarcastle from './TabBar.styles.sugarcastle';
import * as oldgill from './TabBar.styles.oldgill';
import * as buffalobet from './TabBar.styles.buffalobet';
import * as titanbet from './TabBar.styles.titanbet';
import * as templebet from './TabBar.styles.templebet';
import * as slambet from './TabBar.styles.slambet';
import * as gigabet from './TabBar.styles.gigabet';
import * as betstride from './TabBar.styles.betstride';
import * as goldenbet888 from './TabBar.styles.goldenbet888';
import * as hyperbet from './TabBar.styles.hyperbet';
import * as bet777 from './TabBar.styles.bet777';
import * as chromabet from './TabBar.styles.chromabet';
import * as bet575 from './TabBar.styles.bet575';
import * as epicodds from './TabBar.styles.epicodds';
import * as pyramidbet from './TabBar.styles.pyramidbet';
import * as magnumbet from './TabBar.styles.magnumbet';
import { EThemesOG } from '@/constants/themeConfig';

export const styleImports: Partial<Record<EThemesOG, any>> = {
  oldgill,
  betprofessor,
  betroyale,
  fiestabet,
  puntcity,
  puntgenie,
  questbet,
  sterlingparker,
  vikingbet,
  volcanobet,
  wellbet,
  goldenrush,
  juicybet,
  forsport,
  junglebet,
  betgalaxy,
  sugarcastle,
  buffalobet,
  titanbet,
  templebet,
  slambet,
  gigabet,
  betstride,
  goldenbet888,
  hyperbet,
  bet777,
  chromabet,
  bet575,
  epicodds,
  pyramidbet,
  magnumbet,
};
